import React, { Component } from 'react'
import classnames from 'classnames'
import { localize, getLocale } from '../../util/Localizer'
import { ClaimTypes } from '../../redux/SubmitClaim/Common'
import { Row, Col } from 'react-flexbox-grid'
import FileUpload from './FileUpload'
import Config from '../../Config'
import HCSAPopupMessage from '../../util/ui/HCSAPopupMessage'
import Paper from '@material-ui/core/Paper'
import { Colors } from '../../theme'
import { withStyles } from '@material-ui/core/styles'
import RBButton from '../../controls/RBButton'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

class SubmitEmptyState extends Component {
  constructor () {
    super()

    this.returnForm = this.returnForm.bind(this)
    this.dentalAccident = this.dentalAccident.bind(this)
    this.notFound = this.notFound.bind(this)
    this.renderEmptyState = this.renderEmptyState.bind(this)
    this.updateFileList = this.updateFileList.bind(this)
  }

  returnForm () {
    const isDental = ClaimTypes.isDental(this.props.claimObj.type) || (this.props.type === 'dentalAccident')
    let local = getLocale()
    let forms = ''
    const { dentalEN, dentalFR, EOBDrugEN, EOBDrugFR } = Config.claimFormURLs

    if (local === 'en') {
      if (isDental) {
        forms = dentalEN
      } else {
        forms = EOBDrugEN
      }
    } else {
      if (isDental) {
        forms = dentalFR
      } else {
        forms = EOBDrugFR
      }
    }

    return (
      <RBButton
        label={localize('pages.SubmitAClaim.downloadForms')}
        variant='contained'
        primary
        onClick={() => window.open(forms)}
        styles={{ minWidth: 240 }}
      />
    )
  }

  updateFileList (fileList, claimSubmitType) {
    const updates = {
      claimSubmitType,
      ImageContent: fileList || []
    }
    this.props.updateClaim(updates)
    this.updateNext()
  }

  updateNext () {
    if (this.props.memberSummary.healthCareSpendingAccountBalance > 0) {
      const message = HCSAPopupMessage({
        balance: this.props.memberSummary.healthCareSpendingAccountBalance
      })
      this.props.passMessage(message)
    } else if (!this.props.claimSubmitType) {
      this.props.setNext(null)
    } else {
      this.props.setNext(this.props.next)
    }
  }

  dentalAccident () {
    if (this.props.reason === 'dentalAccident') {
      return this.renderEmptyState(localize('pages.SubmitAClaim.dentalAccident'))
    } else return null
  }

  notFound () {
    if (this.props.reason === 'notFound' || this.props.reason === 'notFoundPrac') {
      return this.renderEmptyState(localize('pages.SubmitAClaim.Practitioner.CannotBeFoundText'))// h2>{localize('pages.SubmitAClaim.Practitioner.noSearchResults')}</h2>
    } else return null
  }

  renderEmptyState (text) {
    const { classes = {} } = this.props

    return (
      <Col xs={12} className={classes.emptyState}>
        {this.props.reason === 'notFound' || this.props.reason === 'notFoundPrac'
          ? <h2 className={classes.emptyStateHeading}>
            {localize('pages.SubmitAClaim.Practitioner.noSearchResults')}
          </h2>
          : null}
        <p className={classes.emptyStateMessage}>
          {text}
        </p>
      </Col>
    )
  }

  render () {
    const address = (
      <div>
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Name')}<br />
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Line2')}<br /> {/* these are out of order because nexgen wants po box first */}
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Line1')}<br />
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Line3')}
      </div>)

    const lg = this.props.reason === 'notFoundPrac' ? 4 : 6
    const { clinicName, practitionerTitle = this.props.claimObj.type, classes = {} } = this.props

    const addPracTitle = (clinicName)
      ? `${localize('common.edit')} ${clinicName}`
      : `${localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.title')} ${practitionerTitle}`

    return (
      <div>
        <Row>
          {this.dentalAccident()}
          {this.notFound()}
        </Row>
        <Row center='xs' className={classes.cardRow}>
          {this.props.reason === 'notFoundPrac'
            ? <Col xs={12} lg={lg} className={classes.cardColumn}>
              <Paper className={classes.card}>
                <p className={classes.title}>{addPracTitle}</p>
                <div className={classes.cardBodyContainer}>
                  <i className={classnames('fa fa-user-md fontIcon', classes.icon)} aria-hidden='true' />
                </div>
                <RBButton
                  label={addPracTitle}
                  variant='contained'
                  primary
                  onClick={this.props.addPractitioner}
                />
              </Paper>
            </Col>
            : null}

          <Col xs={12} lg={lg} className={classes.cardColumn}>
            <Paper className={classnames(classes.card, classes.photoCard)}>
              <FileUpload
                onUpdateFileList={this.updateFileList}
                type={this.props.claimObj.claimSubmitType}
                hasCOB={this.props.claimObj && this.props.claimObj.cob}
                fileSize={Config.maxFileSize}
                initialFileList={this.props.initialFileList}
                emptyState
                multiple
                renderPreviewBeforeInput
              />
            </Paper>
          </Col>

          <Col xs={12} lg={lg} className={classes.cardColumn}>
            <Paper className={classes.card}>
              <p className={classes.title}>{localize('pages.SubmitAClaim.Practitioner.ByMail')}</p>
              <div className={classes.cardBodyContainer}>
                <div>{address}</div>
                <p style={{ fontSize: '0.77rem' }}>{localize('pages.SubmitAClaim.Practitioner.CannotBeFoundText2')}</p>
              </div>
              {this.returnForm()}
            </Paper>
          </Col>
        </Row>
      </div>
    )
  }
}

const styles = {
  emptyState: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '& > *': {
      width: '100%' // fix for IE flex-column overflow bug
    }
  },
  emptyStateHeading: {
    color: Colors.Palette.primaryTextColor,
    textAlign: 'center',
    ['@media (max-width: 419px)']: { // eslint-disable-line no-useless-computed-key
      maxWidth: 180
    }
  }, // TODO: Update with the textColor constant after merging this into the styling branch
  emptyStateMessage: {
    textAlign: 'center',
    marginTop: 0,
    ['@media (min-width: 420px) and (max-width: 1200px)']: { // eslint-disable-line no-useless-computed-key
      maxWidth: 360
    }
  },
  cardRow: {
    ['@media (min-width: 993px)']: { // eslint-disable-line no-useless-computed-key
      alignItems: 'stretch'
    }
  },
  cardColumn: {
    ['@media (max-width: 992px)']: { // eslint-disable-line no-useless-computed-key
      marginBottom: 20
    }
  },
  card: {
    border: `1px solid ${Colors.Palette.primaryColor}`,
    height: '100%',
    minHeight: 320,
    padding: '10px 20px',
    borderRadius: 12,
    margin: '10px auto',
    maxWidth: 450,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& > *': {
      width: '100%' // fix for IE flex-column overflow bug
    },
    '& .inlineBlock': {
      width: '100% !important'
    },
    '& button': {
      minWidth: '240px !important',
      maxWidth: '100%',
      marginBottom: 10,
      ['@media (min-width: 993px) and (max-width: 1200px)']: { // eslint-disable-line no-useless-computed-key
        minWidth: 'auto !important',
        width: '100% !important'
      }
    },
    '& .image-preview-row': {
      padding: 0,
      margin: 0
    },
    '& .image-preview-row .row': {
      padding: 0,
      margin: 0
    },
    '& .image-preview-row .col-xs-12': {
      padding: 0,
      margin: 0
    },
    '& .image-preview-row button': {
      minWidth: 'auto !important',
      maxWidth: 'auto !important',
      width: 'auto !important',
      marginBottom: 0
    }
  },
  // Almost everything after this point is terrible, and for that I apologize.
  // However, it looks pretty consistent between IE and good browsers and lets us ship.
  // TODO: We'll revise the empty state cards to eliminate these hacks in the future. (TW)
  photoCard: {
    ['@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)']: { // eslint-disable-line no-useless-computed-key
      display: 'block' // IE-only hack to disable flex display that breaks layout.
    },
    '& i.fa': {
      marginTop: 8,
      marginBottom: 8
    },
    // The following selectors control the layout of content within the image uploader:
    '& > .row': {
      width: '100%',
      height: '100%',
      margin: 0
    },
    '& > .row > div': {
      width: '100%',
      height: '100%',
      margin: 0
    },
    '& > .row > div > div': {
      width: '100%',
      height: '100%'
    },
    '& .boxRow': {
      width: '100%',
      height: '100%',
      margin: 0
    },
    '& .boxRow > div': {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        maxWidth: '100%' // fix for IE flex-column overflow bug
      },
      '& > p:nth-of-type(3)': {
        flex: 1,
        minHeight: 30
      }
    }
    // End image uploader
  },
  title: {
    fontWeight: 500
  },
  cardBodyContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& > *': {
      maxWidth: '100%' // fix for IE flex-column overflow bug
    }
  },
  icon: {
    fontSize: 100,
    margin: 0
  }
}

// export default withStyles(styles)(SubmitEmptyState)

function mapStateToProps (state) {
  return {
    claimObj: state.SubmitAClaimReducer.claimObj || {}
  }
}
const ConnectedSubmitEmptyState = connect(mapStateToProps, {})(injectIntl(SubmitEmptyState))

export default withStyles(styles)(ConnectedSubmitEmptyState)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/SubmitEmptyState.js